import React from 'react';

import * as Antd from 'antd';

const Modal = ({ children, ...props }) => (
  <Antd.Modal {...props} footer={null}>
    {children}
  </Antd.Modal>
);

export default Modal;